const stonyLabUserAgent = window.navigator.userAgent;
const stonyLabIsSafari =
  /Safari/i.test(stonyLabUserAgent) &&
  !/(Chrome|Chromium|CriOS|FxiOS|EdgiOS|OPiOS|Android)/i.test(stonyLabUserAgent);
document.documentElement.classList.toggle('browser-safari', stonyLabIsSafari);

function getFocusableElements(container) {
  return Array.from(
    container.querySelectorAll(
      "summary, a[href], button:enabled, [tabindex]:not([tabindex^='-']), [draggable], area, input:not([type=hidden]):enabled, select:enabled, textarea:enabled, object, iframe"
    )
  );
}
document.querySelectorAll('[id^="Details-"] summary').forEach((summary) => {
  summary.setAttribute('role', 'button');
  summary.setAttribute('aria-expanded', summary.parentNode.hasAttribute('open'));

  if (summary.nextElementSibling.getAttribute('id')) {
    summary.setAttribute('aria-controls', summary.nextElementSibling.id);
  }

  summary.addEventListener('click', (event) => {
    event.currentTarget.setAttribute('aria-expanded', !event.currentTarget.closest('details').hasAttribute('open'));
  });

  if (summary.closest('header-drawer, menu-drawer')) return;
  summary.parentElement.addEventListener('keyup', onKeyUpEscape);
});

const trapFocusHandlers = {};

function trapFocus(container, elementToFocus = container) {
  var elements = getFocusableElements(container);
  var first = elements[0];
  var last = elements[elements.length - 1];

  removeTrapFocus();

  trapFocusHandlers.focusin = (event) => {
    if (event.target !== container && event.target !== last && event.target !== first) return;

    document.addEventListener('keydown', trapFocusHandlers.keydown);
  };

  trapFocusHandlers.focusout = function () {
    document.removeEventListener('keydown', trapFocusHandlers.keydown);
  };

  trapFocusHandlers.keydown = function (event) {
    if (event.code.toUpperCase() !== 'TAB') return; // If not TAB key
    // On the last focusable element and tab forward, focus the first element.
    if (event.target === last && !event.shiftKey) {
      event.preventDefault();
      first.focus();
    }

    //  On the first focusable element and tab backward, focus the last element.
    if ((event.target === container || event.target === first) && event.shiftKey) {
      event.preventDefault();
      last.focus();
    }
  };

  document.addEventListener('focusout', trapFocusHandlers.focusout);
  document.addEventListener('focusin', trapFocusHandlers.focusin);

  elementToFocus.focus();

  if (
    elementToFocus.tagName === 'INPUT' &&
    ['search', 'text', 'email', 'url'].includes(elementToFocus.type) &&
    elementToFocus.value
  ) {
    elementToFocus.setSelectionRange(0, elementToFocus.value.length);
  }
}

// Here run the querySelector to figure out if the browser supports :focus-visible or not and run code based on it.
try {
  document.querySelector(':focus-visible');
} catch (e) {
  focusVisiblePolyfill();
}

function focusVisiblePolyfill() {
  const navKeys = [
    'ARROWUP',
    'ARROWDOWN',
    'ARROWLEFT',
    'ARROWRIGHT',
    'TAB',
    'ENTER',
    'SPACE',
    'ESCAPE',
    'HOME',
    'END',
    'PAGEUP',
    'PAGEDOWN',
  ];
  let currentFocusedElement = null;
  let mouseClick = null;

  window.addEventListener('keydown', (event) => {
    if (navKeys.includes(event.code.toUpperCase())) {
      mouseClick = false;
    }
  });

  window.addEventListener('mousedown', (event) => {
    mouseClick = true;
  });

  window.addEventListener(
    'focus',
    () => {
      if (currentFocusedElement) currentFocusedElement.classList.remove('focused');

      if (mouseClick) return;

      currentFocusedElement = document.activeElement;
      if (currentFocusedElement) currentFocusedElement.classList.add('focused');
    },
    true
  );
}

function pauseAllMedia() {
  document.querySelectorAll('.js-youtube').forEach((video) => {
    video.contentWindow.postMessage('{"event":"command","func":"' + 'pauseVideo' + '","args":""}', '*');
  });
  document.querySelectorAll('.js-vimeo').forEach((video) => {
    video.contentWindow.postMessage('{"method":"pause"}', '*');
  });
  document.querySelectorAll('video').forEach((video) => video.pause());
  document.querySelectorAll('product-model').forEach((model) => {
    if (model.modelViewerUI) model.modelViewerUI.pause();
  });
}

function removeTrapFocus(elementToFocus = null) {
  document.removeEventListener('focusin', trapFocusHandlers.focusin);
  document.removeEventListener('focusout', trapFocusHandlers.focusout);
  document.removeEventListener('keydown', trapFocusHandlers.keydown);

  if (elementToFocus) elementToFocus.focus();
}

function onKeyUpEscape(event) {
  if (event.code.toUpperCase() !== 'ESCAPE') return;

  const openDetailsElement = event.target.closest('details[open]');
  if (!openDetailsElement) return;

  const summaryElement = openDetailsElement.querySelector('summary');
  openDetailsElement.removeAttribute('open');
  summaryElement.setAttribute('aria-expanded', false);
  summaryElement.focus();
}

class QuantityInput extends HTMLElement {
  constructor() {
    super();
    this.input = this.querySelector('input');
    this.changeEvent = new Event('change', { bubbles: true });
    this.input.addEventListener('change', this.onInputChange.bind(this));
    this.querySelectorAll('button').forEach((button) =>
      button.addEventListener('click', this.onButtonClick.bind(this))
    );
  }

  quantityUpdateUnsubscriber = undefined;

  connectedCallback() {
    this.validateQtyRules();
    this.quantityUpdateUnsubscriber = subscribe(PUB_SUB_EVENTS.quantityUpdate, this.validateQtyRules.bind(this));
  }

  disconnectedCallback() {
    if (this.quantityUpdateUnsubscriber) {
      this.quantityUpdateUnsubscriber();
    }
  }

  onInputChange(event) {
    this.validateQtyRules();
  }

  onButtonClick(event) {
    event.preventDefault();
    const previousValue = this.input.value;

    event.target.name === 'plus' ? this.input.stepUp() : this.input.stepDown();
    if (previousValue !== this.input.value) this.input.dispatchEvent(this.changeEvent);
  }

  validateQtyRules() {
    const value = parseInt(this.input.value);
    if (this.input.min) {
      const min = parseInt(this.input.min);
      const buttonMinus = this.querySelector(".quantity__button[name='minus']");
      if (buttonMinus) buttonMinus.classList.toggle('disabled', value <= min);
    }
    if (this.input.max) {
      const max = parseInt(this.input.max);
      const buttonPlus = this.querySelector(".quantity__button[name='plus']");
      if (buttonPlus) buttonPlus.classList.toggle('disabled', value >= max);
    }
  }
}

customElements.define('quantity-input', QuantityInput);

function debounce(fn, wait) {
  let t;
  return (...args) => {
    clearTimeout(t);
    t = setTimeout(() => fn.apply(this, args), wait);
  };
}
function throttle(fn, delay) {
  let lastCall = 0;
  return function (...args) {
    const now = new Date().getTime();
    if (now - lastCall < delay) {
      return;
    }
    lastCall = now;
    return fn(...args);
  };
}

function fetchConfig(type = 'json') {
  return {
    method: 'POST',
    headers: { 'Content-Type': 'application/json', Accept: `application/${type}` },
  };
}

/*
 * Shopify Common JS
 *
 */
if (typeof window.Shopify == 'undefined') {
  window.Shopify = {};
}

Shopify.bind = function (fn, scope) {
  return function () {
    return fn.apply(scope, arguments);
  };
};

Shopify.setSelectorByValue = function (selector, value) {
  for (var i = 0, count = selector.options.length; i < count; i++) {
    var option = selector.options[i];
    if (value == option.value || value == option.innerHTML) {
      selector.selectedIndex = i;
      return i;
    }
  }
};

Shopify.addListener = function (target, eventName, callback) {
  target.addEventListener
    ? target.addEventListener(eventName, callback, false)
    : target.attachEvent('on' + eventName, callback);
};

Shopify.postLink = function (path, options) {
  options = options || {};
  var method = options['method'] || 'post';
  var params = options['parameters'] || {};

  var form = document.createElement('form');
  form.setAttribute('method', method);
  form.setAttribute('action', path);

  for (var key in params) {
    var hiddenField = document.createElement('input');
    hiddenField.setAttribute('type', 'hidden');
    hiddenField.setAttribute('name', key);
    hiddenField.setAttribute('value', params[key]);
    form.appendChild(hiddenField);
  }
  document.body.appendChild(form);
  form.submit();
  document.body.removeChild(form);
};

Shopify.CountryProvinceSelector = function (country_domid, province_domid, options) {
  this.countryEl = document.getElementById(country_domid);
  this.provinceEl = document.getElementById(province_domid);
  this.provinceContainer = document.getElementById(options['hideElement'] || province_domid);

  Shopify.addListener(this.countryEl, 'change', Shopify.bind(this.countryHandler, this));

  this.initCountry();
  this.initProvince();
};

Shopify.CountryProvinceSelector.prototype = {
  initCountry: function () {
    var value = this.countryEl.getAttribute('data-default');
    Shopify.setSelectorByValue(this.countryEl, value);
    this.countryHandler();
  },

  initProvince: function () {
    var value = this.provinceEl.getAttribute('data-default');
    if (value && this.provinceEl.options.length > 0) {
      Shopify.setSelectorByValue(this.provinceEl, value);
    }
  },

  countryHandler: function (e) {
    var opt = this.countryEl.options[this.countryEl.selectedIndex];
    var raw = opt.getAttribute('data-provinces');
    var provinces = JSON.parse(raw);

    this.clearOptions(this.provinceEl);
    if (provinces && provinces.length == 0) {
      this.provinceContainer.style.display = 'none';
    } else {
      for (var i = 0; i < provinces.length; i++) {
        var opt = document.createElement('option');
        opt.value = provinces[i][0];
        opt.innerHTML = provinces[i][1];
        this.provinceEl.appendChild(opt);
      }

      this.provinceContainer.style.display = '';
    }
  },

  clearOptions: function (selector) {
    while (selector.firstChild) {
      selector.removeChild(selector.firstChild);
    }
  },

  setOptions: function (selector, values) {
    for (var i = 0, count = values.length; i < values.length; i++) {
      var opt = document.createElement('option');
      opt.value = values[i];
      opt.innerHTML = values[i];
      selector.appendChild(opt);
    }
  },
};

class MenuDrawer extends HTMLElement {
  constructor() {
    super();

    this.mainDetailsToggle = this.querySelector('details');

    this.addEventListener('keyup', this.onKeyUp.bind(this));
    this.addEventListener('focusout', this.onFocusOut.bind(this));
    this.bindEvents();
  }

  bindEvents() {
    this.querySelectorAll('summary').forEach((summary) =>
      summary.addEventListener('click', this.onSummaryClick.bind(this))
    );
    this.querySelectorAll(
      'button:not(.localization-selector):not(.country-selector__close-button):not(.country-filter__reset-button)'
    ).forEach((button) => button.addEventListener('click', this.onCloseButtonClick.bind(this))
    );
  }

  onKeyUp(event) {
    if (event.code.toUpperCase() !== 'ESCAPE') return;

    const openDetailsElement = event.target.closest('details[open]');
    if (!openDetailsElement) return;

    openDetailsElement === this.mainDetailsToggle
      ? this.closeMenuDrawer(event, this.mainDetailsToggle.querySelector('summary'))
      : this.closeSubmenu(openDetailsElement);
  }

  onSummaryClick(event) {
    const summaryElement = event.currentTarget;
    const detailsElement = summaryElement.parentNode;
    const parentMenuElement = detailsElement.closest('.has-submenu');
    const isOpen = detailsElement.hasAttribute('open');
    const reducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)');

    function addTrapFocus() {
      trapFocus(summaryElement.nextElementSibling, detailsElement.querySelector('button'));
      summaryElement.nextElementSibling.removeEventListener('transitionend', addTrapFocus);
    }

    if (detailsElement === this.mainDetailsToggle) {
      if (isOpen) event.preventDefault();
      isOpen ? this.closeMenuDrawer(event, summaryElement) : this.openMenuDrawer(summaryElement);

      if (window.matchMedia('(max-width: 990px)')) {
        document.documentElement.style.setProperty('--viewport-height', `${window.innerHeight}px`);
      }
    } else {
      setTimeout(() => {
        detailsElement.classList.add('menu-opening');
        summaryElement.setAttribute('aria-expanded', true);
        parentMenuElement && parentMenuElement.classList.add('submenu-open');
        !reducedMotion || reducedMotion.matches
          ? addTrapFocus()
          : summaryElement.nextElementSibling.addEventListener('transitionend', addTrapFocus);
      }, 100);
    }
  }

  openMenuDrawer(summaryElement) {
    setTimeout(() => {
      this.mainDetailsToggle.classList.add('menu-opening');
    });
    summaryElement.setAttribute('aria-expanded', true);
    trapFocus(this.mainDetailsToggle, summaryElement);
    document.body.classList.add(`overflow-hidden-${this.dataset.breakpoint}`);
  }

  closeMenuDrawer(event, elementToFocus = false) {
    if (event === undefined) return;

    this.mainDetailsToggle.classList.remove('menu-opening');
    this.mainDetailsToggle.querySelectorAll('details').forEach((details) => {
      details.removeAttribute('open');
      details.classList.remove('menu-opening');
    });
    this.mainDetailsToggle.querySelectorAll('.submenu-open').forEach((submenu) => {
      submenu.classList.remove('submenu-open');
    });
    document.body.classList.remove(`overflow-hidden-${this.dataset.breakpoint}`);
    removeTrapFocus(elementToFocus);
    this.closeAnimation(this.mainDetailsToggle);

    if (event instanceof KeyboardEvent) elementToFocus?.setAttribute('aria-expanded', false);
  }

  onFocusOut() {
    setTimeout(() => {
      if (this.mainDetailsToggle.hasAttribute('open') && !this.mainDetailsToggle.contains(document.activeElement))
        this.closeMenuDrawer();
    });
  }

  onCloseButtonClick(event) {
    const detailsElement = event.currentTarget.closest('details');
    this.closeSubmenu(detailsElement);
  }

  closeSubmenu(detailsElement) {
    const parentMenuElement = detailsElement.closest('.submenu-open');
    parentMenuElement && parentMenuElement.classList.remove('submenu-open');
    detailsElement.classList.remove('menu-opening');
    detailsElement.querySelector('summary').setAttribute('aria-expanded', false);
    removeTrapFocus(detailsElement.querySelector('summary'));
    this.closeAnimation(detailsElement);
  }

  closeAnimation(detailsElement) {
    let animationStart;

    const handleAnimation = (time) => {
      if (animationStart === undefined) {
        animationStart = time;
      }

      const elapsedTime = time - animationStart;

      if (elapsedTime < 400) {
        window.requestAnimationFrame(handleAnimation);
      } else {
        detailsElement.removeAttribute('open');
        if (detailsElement.closest('details[open]')) {
          trapFocus(detailsElement.closest('details[open]'), detailsElement.querySelector('summary'));
        }
      }
    };

    window.requestAnimationFrame(handleAnimation);
  }
}

customElements.define('menu-drawer', MenuDrawer);

class HeaderDrawer extends MenuDrawer {
  constructor() {
    super();
  }

  openMenuDrawer(summaryElement) {
    this.header = this.header || document.querySelector('.section-header');
    this.borderOffset =
      this.borderOffset || this.closest('.header-wrapper').classList.contains('header-wrapper--border-bottom') ? 1 : 0;
    document.documentElement.style.setProperty(
      '--header-bottom-position',
      `${parseInt(this.header.getBoundingClientRect().bottom - this.borderOffset)}px`
    );
    this.header.classList.add('menu-open');

    setTimeout(() => {
      this.mainDetailsToggle.classList.add('menu-opening');
    });

    summaryElement.setAttribute('aria-expanded', true);
    window.addEventListener('resize', this.onResize);
    trapFocus(this.mainDetailsToggle, summaryElement);
    document.body.classList.add(`overflow-hidden-${this.dataset.breakpoint}`);
  }

  closeMenuDrawer(event, elementToFocus) {
    if (!elementToFocus) return;
    super.closeMenuDrawer(event, elementToFocus);
    this.header.classList.remove('menu-open');
    window.removeEventListener('resize', this.onResize);
  }

  onResize = () => {
    this.header &&
      document.documentElement.style.setProperty(
        '--header-bottom-position',
        `${parseInt(this.header.getBoundingClientRect().bottom - this.borderOffset)}px`
      );
    document.documentElement.style.setProperty('--viewport-height', `${window.innerHeight}px`);
  };
}

customElements.define('header-drawer', HeaderDrawer);

class ModalDialog extends HTMLElement {
  constructor() {
    super();
    this.querySelector('[id^="ModalClose-"]').addEventListener('click', this.hide.bind(this, false));
    this.addEventListener('keyup', (event) => {
      if (event.code.toUpperCase() === 'ESCAPE') this.hide();
    });
    if (this.classList.contains('media-modal')) {
      this.addEventListener('pointerup', (event) => {
        if (event.pointerType === 'mouse' && !event.target.closest('deferred-media, product-model')) this.hide();
      });
    } else {
      this.addEventListener('click', (event) => {
        if (event.target === this) this.hide();
      });
    }
  }

  connectedCallback() {
    if (this.moved) return;
    this.moved = true;
    document.body.appendChild(this);
  }

  show(opener) {
    this.openedBy = opener;
    const popup = this.querySelector('.template-popup');
    document.body.classList.add('overflow-hidden');
    this.setAttribute('open', '');
    if (popup) popup.loadContent();
    trapFocus(this, this.querySelector('[role="dialog"]'));
    window.pauseAllMedia();
  }

  hide() {
    document.body.classList.remove('overflow-hidden');
    document.body.dispatchEvent(new CustomEvent('modalClosed'));
    this.removeAttribute('open');
    removeTrapFocus(this.openedBy);
    window.pauseAllMedia();
  }
}
customElements.define('modal-dialog', ModalDialog);

class ModalOpener extends HTMLElement {
  constructor() {
    super();

    const button = this.querySelector('button');

    if (!button) return;
    const mobileMediaQuery = window.matchMedia('(max-width: 749px)');
    const isProductImage = this.matches('.product__modal-opener--image');

    const updateMobileImageZoom = () => {
      if (isProductImage) button.toggleAttribute('disabled', mobileMediaQuery.matches);
    };

    updateMobileImageZoom();
    mobileMediaQuery.addEventListener('change', updateMobileImageZoom);

    button.addEventListener('click', () => {
      if (this.matches('.product__modal-opener') && mobileMediaQuery.matches) {
        const mediaItem = this.closest('.product__media-item[data-media-id]');
        const mediaGallery = this.closest('media-gallery');

        if (!isProductImage && mediaItem && typeof mediaGallery?.setActiveMedia === 'function') {
          mediaGallery.setActiveMedia(mediaItem.dataset.mediaId, false);
        }
        return;
      }

      const modal = document.querySelector(this.getAttribute('data-modal'));
      if (modal) modal.show(button);
    });
  }
}
customElements.define('modal-opener', ModalOpener);

class DeferredMedia extends HTMLElement {
  constructor() {
    super();
    const poster = this.querySelector('[id^="Deferred-Poster-"]');
    if (!poster) return;
    poster.addEventListener('click', this.loadContent.bind(this));
  }

  loadContent(focus = true) {
    window.pauseAllMedia();
    if (!this.getAttribute('loaded')) {
      const content = document.createElement('div');
      content.appendChild(this.querySelector('template').content.firstElementChild.cloneNode(true));

      this.setAttribute('loaded', true);
      const deferredElement = this.appendChild(content.querySelector('video, model-viewer, iframe'));
      if (focus) deferredElement.focus();
      if (deferredElement.nodeName == 'VIDEO' && deferredElement.getAttribute('autoplay')) {
        // force autoplay for safari
        deferredElement.play();
      }
    }
  }
}

customElements.define('deferred-media', DeferredMedia);

class SliderComponent extends HTMLElement {
  constructor() {
    super();
    this.slider = this.querySelector('[id^="Slider-"]');
    this.sliderItems = this.querySelectorAll('[id^="Slide-"]');
    this.enableSliderLooping = false;
    const externalPageCounter = this.slider
      ? this.parentElement?.querySelector(`[data-slider-counter="${this.slider.id}"]`)
      : null;
    this.currentPageElements = Array.from(this.querySelectorAll('.slider-counter--current'));
    this.pageTotalElements = Array.from(this.querySelectorAll('.slider-counter--total'));
    if (externalPageCounter) {
      this.currentPageElements.push(...externalPageCounter.querySelectorAll('.slider-counter--current'));
      this.pageTotalElements.push(...externalPageCounter.querySelectorAll('.slider-counter--total'));
    }
    this.currentPageElement = this.currentPageElements[0];
    this.pageTotalElement = this.pageTotalElements[0];
    this.prevButton = this.querySelector('button[name="previous"]');
    this.nextButton = this.querySelector('button[name="next"]');
    this.slideByPage = this.dataset.slideBy === 'page';

    if (!this.slider || !this.nextButton) return;

    this.initPages();
    const resizeObserver = new ResizeObserver((entries) => this.initPages());
    resizeObserver.observe(this.slider);

    this.slider.addEventListener('scroll', this.update.bind(this));
    this.prevButton.addEventListener('click', this.onButtonClick.bind(this));
    this.nextButton.addEventListener('click', this.onButtonClick.bind(this));
  }

  initPages() {
    this.sliderItemsToShow = Array.from(this.sliderItems).filter((element) => element.clientWidth > 0);
    if (this.sliderItemsToShow.length < 2) return;
    this.updateNavigationPosition();
    this.sliderItemOffset = this.sliderItemsToShow[1].offsetLeft - this.sliderItemsToShow[0].offsetLeft;
    // Dividing by the slide stride undercounts by one when the row includes gaps.
    const viewportEnd = this.slider.clientWidth + 1;
    const measuredSlidesPerPage = Math.max(
      1,
      this.sliderItemsToShow.filter((element) => element.offsetLeft + element.clientWidth <= viewportEnd).length
    );
    const desktopSlidesPerPage = Number(this.dataset.desktopSlidesPerPage);
    const hasConfiguredDesktopPageSize =
      this.slideByPage &&
      window.matchMedia('(min-width: 990px)').matches &&
      Number.isInteger(desktopSlidesPerPage) &&
      desktopSlidesPerPage > 0;

    this.slidesPerPage = hasConfiguredDesktopPageSize ? desktopSlidesPerPage : measuredSlidesPerPage;
    this.totalPages = this.slideByPage
      ? Math.ceil(this.sliderItemsToShow.length / this.slidesPerPage)
      : this.sliderItemsToShow.length - this.slidesPerPage + 1;

    this.slider.style.removeProperty('--slider-page-end-spacer');
    const finalPageItemCount = this.sliderItemsToShow.length % this.slidesPerPage;
    if (hasConfiguredDesktopPageSize && this.totalPages > 1 && finalPageItemCount > 0) {
      const finalPageStartIndex = this.sliderItemsToShow.length - finalPageItemCount;
      const finalPageStart = this.sliderItemsToShow[finalPageStartIndex].offsetLeft;
      const lastItem = this.sliderItemsToShow[this.sliderItemsToShow.length - 1];
      const lastItemEnd = lastItem.offsetLeft + lastItem.clientWidth;
      const endSpacer = Math.max(0, Math.ceil(finalPageStart + this.slider.clientWidth - lastItemEnd));

      this.slider.style.setProperty('--slider-page-end-spacer', `${endSpacer}px`);
    }
    this.update();
  }

  updateNavigationPosition() {
    const firstCardMedia = this.sliderItemsToShow[0].querySelector('.card__inner');
    if (!firstCardMedia) return;

    let mediaOffsetTop = 0;
    let currentElement = firstCardMedia;

    while (currentElement && currentElement !== this) {
      mediaOffsetTop += currentElement.offsetTop;
      currentElement = currentElement.offsetParent;
    }

    if (currentElement !== this) return;

    this.style.setProperty('--slider-navigation-top', `${mediaOffsetTop + firstCardMedia.offsetHeight}px`);
  }

  resetPages() {
    this.sliderItems = this.querySelectorAll('[id^="Slide-"]');
    this.initPages();
  }

  update() {
    // Temporarily prevents unneeded updates resulting from variant changes
    // This should be refactored as part of https://github.com/Shopify/dawn/issues/2057
    if (!this.slider || !this.nextButton || !this.sliderItemsToShow?.length) return;

    const previousPage = this.currentPage;
    const currentSlideIndex = Math.round(this.slider.scrollLeft / this.sliderItemOffset);
    this.currentPage = this.slideByPage
      ? Math.min(Math.ceil(currentSlideIndex / this.slidesPerPage) + 1, this.totalPages)
      : currentSlideIndex + 1;

    if (this.currentPageElements.length && this.pageTotalElements.length) {
      this.currentPageElements.forEach((element) => (element.textContent = this.currentPage));
      this.pageTotalElements.forEach((element) => (element.textContent = this.totalPages));
    }

    if (this.currentPage != previousPage) {
      this.dispatchEvent(
        new CustomEvent('slideChanged', {
          detail: {
            currentPage: this.currentPage,
            currentElement: this.sliderItemsToShow[currentSlideIndex],
          },
        })
      );
    }

    if (this.enableSliderLooping) return;

    if (this.isSlideVisible(this.sliderItemsToShow[0]) && this.slider.scrollLeft === 0) {
      this.prevButton.setAttribute('disabled', 'disabled');
    } else {
      this.prevButton.removeAttribute('disabled');
    }

    if (this.isSlideVisible(this.sliderItemsToShow[this.sliderItemsToShow.length - 1])) {
      this.nextButton.setAttribute('disabled', 'disabled');
    } else {
      this.nextButton.removeAttribute('disabled');
    }
  }

  isSlideVisible(element, offset = 0) {
    const lastVisibleSlide = this.slider.clientWidth + this.slider.scrollLeft - offset;
    return element.offsetLeft + element.clientWidth <= lastVisibleSlide && element.offsetLeft >= this.slider.scrollLeft;
  }

  onButtonClick(event) {
    event.preventDefault();
    const configuredStep = event.currentTarget.dataset.step;
    const step = configuredStep === 'page' || this.slideByPage ? this.slidesPerPage : Number(configuredStep) || 1;
    const maxScrollPosition = this.slider.scrollWidth - this.slider.clientWidth;
    this.slideScrollPosition =
      event.currentTarget.name === 'next'
        ? this.slider.scrollLeft + step * this.sliderItemOffset
        : this.slider.scrollLeft - step * this.sliderItemOffset;
    this.slideScrollPosition = Math.min(Math.max(this.slideScrollPosition, 0), maxScrollPosition);
    this.setSlidePosition(this.slideScrollPosition);
  }

  setSlidePosition(position) {
    this.slider.scrollTo({
      left: position,
    });
  }
}

customElements.define('slider-component', SliderComponent);

class SlideshowComponent extends SliderComponent {
  constructor() {
    super();
    this.sliderControlWrapper = this.querySelector('.slider-buttons');
    this.enableSliderLooping = true;

    if (!this.sliderControlWrapper) return;

    this.sliderFirstItemNode = this.slider.querySelector('.slideshow__slide');
    if (this.sliderItemsToShow.length > 0) this.currentPage = 1;

    this.announcementBarSlider = this.querySelector('.announcement-bar-slider');
    // Value below should match --duration-announcement-bar CSS value
    this.announcerBarAnimationDelay = this.announcementBarSlider ? 250 : 0;

    this.sliderControlLinksArray = Array.from(this.sliderControlWrapper.querySelectorAll('.slider-counter__link'));
    this.sliderControlLinksArray.forEach((link) => link.addEventListener('click', this.linkToSlide.bind(this)));
    this.slider.addEventListener('scroll', this.setSlideVisibility.bind(this));
    this.setSlideVisibility();

    if (this.announcementBarSlider) {
      this.announcementBarArrowButtonWasClicked = false;

      this.reducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)');
      this.reducedMotion.addEventListener('change', () => {
        if (this.slider.getAttribute('data-autoplay') === 'true') this.setAutoPlay();
      });

      [this.prevButton, this.nextButton].forEach((button) => {
        button.addEventListener(
          'click',
          () => {
            this.announcementBarArrowButtonWasClicked = true;
          },
          { once: true }
        );
      });
    }

    if (this.slider.getAttribute('data-autoplay') === 'true') this.setAutoPlay();
  }

  setAutoPlay() {
    this.autoplaySpeed = this.slider.dataset.speed * 1000;
    this.addEventListener('mouseover', this.focusInHandling.bind(this));
    this.addEventListener('mouseleave', this.focusOutHandling.bind(this));
    this.addEventListener('focusin', this.focusInHandling.bind(this));
    this.addEventListener('focusout', this.focusOutHandling.bind(this));

    if (this.querySelector('.slideshow__autoplay')) {
      this.sliderAutoplayButton = this.querySelector('.slideshow__autoplay');
      this.sliderAutoplayButton.addEventListener('click', this.autoPlayToggle.bind(this));
      this.autoplayButtonIsSetToPlay = true;
      this.play();
    } else {
      this.reducedMotion.matches || this.announcementBarArrowButtonWasClicked ? this.pause() : this.play();
    }
  }

  onButtonClick(event) {
    super.onButtonClick(event);
    this.wasClicked = true;

    const isFirstSlide = this.currentPage === 1;
    const isLastSlide = this.currentPage === this.sliderItemsToShow.length;

    if (!isFirstSlide && !isLastSlide) {
      this.applyAnimationToAnnouncementBar(event.currentTarget.name);
      return;
    }

    if (isFirstSlide && event.currentTarget.name === 'previous') {
      this.slideScrollPosition =
        this.slider.scrollLeft + this.sliderFirstItemNode.clientWidth * this.sliderItemsToShow.length;
    } else if (isLastSlide && event.currentTarget.name === 'next') {
      this.slideScrollPosition = 0;
    }

    this.setSlidePosition(this.slideScrollPosition);

    this.applyAnimationToAnnouncementBar(event.currentTarget.name);
  }

  setSlidePosition(position) {
    if (this.setPositionTimeout) clearTimeout(this.setPositionTimeout);
    this.setPositionTimeout = setTimeout(() => {
      this.slider.scrollTo({
        left: position,
      });
    }, this.announcerBarAnimationDelay);
  }

  update() {
    super.update();
    this.sliderControlButtons = this.querySelectorAll('.slider-counter__link');
    this.prevButton.removeAttribute('disabled');

    if (!this.sliderControlButtons.length) return;

    this.sliderControlButtons.forEach((link) => {
      link.classList.remove('slider-counter__link--active');
      link.removeAttribute('aria-current');
    });
    this.sliderControlButtons[this.currentPage - 1].classList.add('slider-counter__link--active');
    this.sliderControlButtons[this.currentPage - 1].setAttribute('aria-current', true);
  }

  autoPlayToggle() {
    this.togglePlayButtonState(this.autoplayButtonIsSetToPlay);
    this.autoplayButtonIsSetToPlay ? this.pause() : this.play();
    this.autoplayButtonIsSetToPlay = !this.autoplayButtonIsSetToPlay;
  }

  focusOutHandling(event) {
    if (this.sliderAutoplayButton) {
      const focusedOnAutoplayButton =
        event.target === this.sliderAutoplayButton || this.sliderAutoplayButton.contains(event.target);
      if (!this.autoplayButtonIsSetToPlay || focusedOnAutoplayButton) return;
      this.play();
    } else if (!this.reducedMotion.matches && !this.announcementBarArrowButtonWasClicked) {
      this.play();
    }
  }

  focusInHandling(event) {
    if (this.sliderAutoplayButton) {
      const focusedOnAutoplayButton =
        event.target === this.sliderAutoplayButton || this.sliderAutoplayButton.contains(event.target);
      if (focusedOnAutoplayButton && this.autoplayButtonIsSetToPlay) {
        this.play();
      } else if (this.autoplayButtonIsSetToPlay) {
        this.pause();
      }
    } else if (this.announcementBarSlider.contains(event.target)) {
      this.pause();
    }
  }

  play() {
    this.slider.setAttribute('aria-live', 'off');
    clearInterval(this.autoplay);
    this.autoplay = setInterval(this.autoRotateSlides.bind(this), this.autoplaySpeed);
  }

  pause() {
    this.slider.setAttribute('aria-live', 'polite');
    clearInterval(this.autoplay);
  }

  togglePlayButtonState(pauseAutoplay) {
    if (pauseAutoplay) {
      this.sliderAutoplayButton.classList.add('slideshow__autoplay--paused');
      this.sliderAutoplayButton.setAttribute('aria-label', window.accessibilityStrings.playSlideshow);
    } else {
      this.sliderAutoplayButton.classList.remove('slideshow__autoplay--paused');
      this.sliderAutoplayButton.setAttribute('aria-label', window.accessibilityStrings.pauseSlideshow);
    }
  }

  autoRotateSlides() {
    if (
      window.matchMedia('(max-width: 749px)').matches &&
      (!this.sliderItemsToShow?.length || !Number.isFinite(this.currentPage))
    )
      return;

    const slideScrollPosition =
      this.currentPage === this.sliderItems.length ? 0 : this.slider.scrollLeft + this.sliderItemOffset;

    this.setSlidePosition(slideScrollPosition);
    this.applyAnimationToAnnouncementBar();
  }

  setSlideVisibility(event) {
    this.sliderItemsToShow.forEach((item, index) => {
      const linkElements = item.querySelectorAll('a');
      if (index === this.currentPage - 1) {
        if (linkElements.length)
          linkElements.forEach((button) => {
            button.removeAttribute('tabindex');
          });
        item.setAttribute('aria-hidden', 'false');
        item.removeAttribute('tabindex');
      } else {
        if (linkElements.length)
          linkElements.forEach((button) => {
            button.setAttribute('tabindex', '-1');
          });
        item.setAttribute('aria-hidden', 'true');
        item.setAttribute('tabindex', '-1');
      }
    });
    this.wasClicked = false;
  }

  applyAnimationToAnnouncementBar(button = 'next') {
    if (!this.announcementBarSlider) return;

    const itemsCount = this.sliderItems.length;
    if (
      window.matchMedia('(max-width: 749px)').matches &&
      (itemsCount < 2 || !Number.isFinite(this.currentPage))
    )
      return;
    const increment = button === 'next' ? 1 : -1;

    const currentIndex = this.currentPage - 1;
    let nextIndex = (currentIndex + increment) % itemsCount;
    nextIndex = nextIndex === -1 ? itemsCount - 1 : nextIndex;

    const nextSlide = this.sliderItems[nextIndex];
    const currentSlide = this.sliderItems[currentIndex];
    if (window.matchMedia('(max-width: 749px)').matches && (!currentSlide || !nextSlide)) return;

    const animationClassIn = 'announcement-bar-slider--fade-in';
    const animationClassOut = 'announcement-bar-slider--fade-out';

    const isFirstSlide = currentIndex === 0;
    const isLastSlide = currentIndex === itemsCount - 1;

    const shouldMoveNext = (button === 'next' && !isLastSlide) || (button === 'previous' && isFirstSlide);
    const direction = shouldMoveNext ? 'next' : 'previous';

    currentSlide.classList.add(`${animationClassOut}-${direction}`);
    nextSlide.classList.add(`${animationClassIn}-${direction}`);

    setTimeout(() => {
      currentSlide.classList.remove(`${animationClassOut}-${direction}`);
      nextSlide.classList.remove(`${animationClassIn}-${direction}`);
    }, this.announcerBarAnimationDelay * 2);
  }

  linkToSlide(event) {
    event.preventDefault();
    const slideScrollPosition =
      this.slider.scrollLeft +
      this.sliderFirstItemNode.clientWidth *
        (this.sliderControlLinksArray.indexOf(event.currentTarget) + 1 - this.currentPage);
    this.slider.scrollTo({
      left: slideScrollPosition,
    });
  }
}

customElements.define('slideshow-component', SlideshowComponent);
class VariantSelects extends HTMLElement {
  constructor() {
    super();
    this.addEventListener('change', this.onVariantChange);
  }

  onVariantChange(event) {
    this.updateOptions();
    this.updateMasterId();
    this.updateSelectedSwatchValue(event);
    this.toggleAddButton(true, '', false);
    this.updatePickupAvailability();
    this.removeErrorMessage();
    this.updateVariantStatuses();
    if (!this.currentVariant) {
      this.toggleAddButton(true, '', true);
      this.setUnavailable();
    } else {
      const gpoSel = document.querySelector(".product-my-button-pc .gpoVariantSelector");
      if (gpoSel) gpoSel.value = this.currentVariant.id;
      this.renderProductInfo();
      this.updateVariantInput();
      this.updateURL();
      this.updateSku();
      this.updateShareUrl();
      this.updateMedia();
      // if(typeof Globo != "undefined" && typeof Globo.Preorder != "undefined" ) {
      //    Globo.Preorder.initPreorder?.();
      //    Globo.Preorder.showPreorderLabel?.();
      // }
    }
  }
  updateSku() {
    getSku(this.currentVariant.id);

  }
  updateOptions() {
    this.options = Array.from(this.querySelectorAll('select, fieldset'), (element) => {
      if (element.tagName === 'SELECT') {
        return element.value;
      }
      if (element.tagName === 'FIELDSET') {
        return Array.from(element.querySelectorAll('input')).find((radio) => radio.checked)?.value;
      }
    });
  }

  

  updateMasterId() {
    this.currentVariant = this.getVariantData().find((variant) => {
      return !variant.options
        .map((option, index) => {
          return this.options[index] === option;
        })
        .includes(false);
    });
  }

  updateSelectedSwatchValue({ target }) {
    const { name, value, tagName } = target;

    if (tagName === 'SELECT' && target.selectedOptions.length) {
      const swatchValue = target.selectedOptions[0].dataset.optionSwatchValue;
      const selectedDropdownSwatchValue = this.querySelector(`[data-selected-dropdown-swatch="${name}"] > .swatch`);
      if (!selectedDropdownSwatchValue) return;
      if (swatchValue) {
        selectedDropdownSwatchValue.style.setProperty('--swatch--background', swatchValue);
        selectedDropdownSwatchValue.classList.remove('swatch--unavailable');
      } else {
        selectedDropdownSwatchValue.style.setProperty('--swatch--background', 'unset');
        selectedDropdownSwatchValue.classList.add('swatch--unavailable');
      }
    } else if (tagName === 'INPUT' && target.type === 'radio') {
      const selectedSwatchValue = this.querySelector(`[data-selected-swatch-value="${name}"]`);
      if (selectedSwatchValue) selectedSwatchValue.innerHTML = value;
    }
  }

  updateMedia() {
    if (!this.currentVariant) return;
    if (!this.currentVariant.featured_media) return;

    const mediaGalleries = document.querySelectorAll(`[id^="MediaGallery-${this.dataset.section}"]`);
    mediaGalleries.forEach((mediaGallery) =>
      mediaGallery.setActiveMedia(`${this.dataset.section}-${this.currentVariant.featured_media.id}`, true)
    );

    const productModal = document.querySelector(`#ProductModal-${this.dataset.section}`);
    const modalContent = productModal?.querySelector('.product-media-modal__content');
    if (!modalContent) return;

    if (modalContent.classList.contains('product-media-modal__content--gallery')) {
      productModal.setCurrentVariant?.(this.currentVariant.id, this.currentVariant.featured_media.id);
      return;
    }

    const newMediaModal = modalContent.querySelector(`[data-media-id="${this.currentVariant.featured_media.id}"]`);
    if (!newMediaModal) return;
    modalContent.prepend(newMediaModal);
  }

  updateURL() {
    if (!this.currentVariant || this.dataset.updateUrl === 'false') return;
    window.history.replaceState({}, '', `${this.dataset.url}?variant=${this.currentVariant.id}`);
  }

  updateShareUrl() {
    const shareButton = document.getElementById(`Share-${this.dataset.section}`);
    if (!shareButton || !shareButton.updateUrl) return;
    shareButton.updateUrl(`${window.shopUrl}${this.dataset.url}?variant=${this.currentVariant.id}`);
  }

  updateVariantInput() {
    var productForms = document.querySelectorAll(
      '#product-form-' + this.dataset.section
      + ', #product-form-installment-' + this.dataset.section
      + ', #product-form-' + this.dataset.section + '-desktop'
    );
    productForms.forEach((productForm) => {
      const input = productForm.querySelector('input[name="id"]');
      input.value = this.currentVariant.id;
      input.dispatchEvent(new Event('change', { bubbles: true }));
    });
  }

  updateVariantStatuses() {
    const selectedOptionOneVariants = this.variantData.filter(
      (variant) => this.querySelector(':checked').value === variant.option1
    );
    const inputWrappers = [...this.querySelectorAll('.product-form__input')];
    inputWrappers.forEach((option, index) => {
      if (index === 0) return;
      const optionInputs = [...option.querySelectorAll('input[type="radio"], option')];
      const previousOptionSelected = inputWrappers[index - 1].querySelector(':checked').value;
      const availableOptionInputsValue = selectedOptionOneVariants
        .filter((variant) => variant.available && variant[`option${index}`] === previousOptionSelected)
        .map((variantOption) => variantOption[`option${index + 1}`]);
      this.setInputAvailability(optionInputs, availableOptionInputsValue);
    });
  }

  setInputAvailability(elementList, availableValuesList) {
    elementList.forEach((element) => {
      const value = element.getAttribute('value');
      const availableElement = availableValuesList.includes(value);

      if (element.tagName === 'INPUT') {
        element.classList.toggle('disabled', !availableElement);
      } else if (element.tagName === 'OPTION') {
        element.innerText = availableElement
          ? value
          : window.variantStrings.unavailable_with_option.replace('[value]', value);
      }
    });
  }

  updatePickupAvailability() {
    const pickUpAvailability = document.querySelector('pickup-availability');
    if (!pickUpAvailability) return;

    if (this.currentVariant && this.currentVariant.available) {
      pickUpAvailability.fetchAvailability(this.currentVariant.id);
    } else {
      pickUpAvailability.removeAttribute('available');
      pickUpAvailability.innerHTML = '';
    }
  }

  removeErrorMessage() {
    const section = this.closest('section');
    if (!section) return;

    const productForm = section.querySelector('product-form');
    if (productForm) productForm.handleErrorMessage();
  }

  renderProductInfo() {
    const requestedVariantId = this.currentVariant.id;
    const sectionId = this.dataset.originalSection ? this.dataset.originalSection : this.dataset.section;

    fetch(
      `${this.dataset.url}?variant=${requestedVariantId}&section_id=${
        this.dataset.originalSection ? this.dataset.originalSection : this.dataset.section
      }`
    )
      .then((response) => response.text())
      .then((responseText) => {
        // prevent unnecessary ui changes from abandoned selections
        if (this.currentVariant.id !== requestedVariantId) return;

        const html = new DOMParser().parseFromString(responseText, 'text/html');
        const destination = document.getElementById(`price-${this.dataset.section}`);
        //增加商品页右侧价格
        const destination2 = document.getElementById(`price-${this.dataset.section}2`);
        const source = html.getElementById(
          `price-${this.dataset.originalSection ? this.dataset.originalSection : this.dataset.section}`
        );
        const skuSource = html.getElementById(
          `Sku-${this.dataset.originalSection ? this.dataset.originalSection : this.dataset.section}`
        );
        const skuDestination = document.getElementById(`Sku-${this.dataset.section}`);
        const inventorySource = html.getElementById(
          `Inventory-${this.dataset.originalSection ? this.dataset.originalSection : this.dataset.section}`
        );
        const inventoryDestination = document.getElementById(`Inventory-${this.dataset.section}`);

        const volumePricingSource = html.getElementById(
          `Volume-${this.dataset.originalSection ? this.dataset.originalSection : this.dataset.section}`
        );

        const pricePerItemDestination = document.getElementById(`Price-Per-Item-${this.dataset.section}`);
        const pricePerItemSource = html.getElementById(
          `Price-Per-Item-${this.dataset.originalSection ? this.dataset.originalSection : this.dataset.section}`
        );

        const volumePricingDestination = document.getElementById(`Volume-${this.dataset.section}`);
        const qtyRules = document.getElementById(`Quantity-Rules-${this.dataset.section}`);
        const volumeNote = document.getElementById(`Volume-Note-${this.dataset.section}`);

        if (volumeNote) volumeNote.classList.remove('hidden');
        if (volumePricingDestination) volumePricingDestination.classList.remove('hidden');
        if (qtyRules) qtyRules.classList.remove('hidden');

        if (source && destination) destination.innerHTML = source.innerHTML;
        if (source && destination2) destination2.innerHTML = source.innerHTML;
        if (inventorySource && inventoryDestination) inventoryDestination.innerHTML = inventorySource.innerHTML;
        if (skuSource && skuDestination) {
          skuDestination.innerHTML = skuSource.innerHTML;
          skuDestination.classList.toggle('hidden', skuSource.classList.contains('hidden'));
        }

        if (volumePricingSource && volumePricingDestination) {
          volumePricingDestination.innerHTML = volumePricingSource.innerHTML;
        }

        if (pricePerItemSource && pricePerItemDestination) {
          pricePerItemDestination.innerHTML = pricePerItemSource.innerHTML;
          pricePerItemDestination.classList.toggle('hidden', pricePerItemSource.classList.contains('hidden'));
        }

        const price = document.getElementById(`price-${this.dataset.section}`);

        if (price) price.classList.remove('hidden');

        if (inventoryDestination) inventoryDestination.classList.toggle('hidden', inventorySource.innerText === '');

        const addButtonUpdated = html.getElementById(`ProductSubmitButton-${sectionId}`);
        this.toggleAddButton(
          addButtonUpdated ? addButtonUpdated.hasAttribute('disabled') : true,
          window.variantStrings.soldOut
        );
      //      // ========== 新增：更新右侧按钮 ==========
      // const rightProductForm = document.getElementById(`product-form-${this.dataset.section}-desktop`);
      // if (rightProductForm) {
      //   // 更新隐藏的 variant id
      //   const rightIdInput = rightProductForm.querySelector('input[name="id"]');
      //   if (rightIdInput) rightIdInput.value = this.currentVariant.id;

      //   // 更新提交按钮状态和文本
      //   const rightAddButton = rightProductForm.querySelector('[name="add"]');
      //   if (rightAddButton) {
      //     // 从返回的 HTML 中找到对应的右侧按钮（如果有）来判断状态
      //     const newRightButton = html.querySelector(`#product-form-${this.dataset.section}-desktop [name="add"]`);
      //     if (newRightButton) {
      //       rightAddButton.disabled = newRightButton.disabled;
      //       const rightAddButtonSpan = rightAddButton.querySelector('span');
      //       const newRightButtonSpan = newRightButton.querySelector('span');
      //       if (rightAddButtonSpan && newRightButtonSpan) {
      //         rightAddButtonSpan.textContent = newRightButtonSpan.textContent;
      //       }
      //     } else {
      //       // 如果返回的 HTML 中没有右侧按钮（理论上不应该），则根据当前变体设置
      //       if (!this.currentVariant.available) {
      //         rightAddButton.disabled = true;
      //         const span = rightAddButton.querySelector('span');
      //         if (span) span.textContent = window.variantStrings.soldOut;
      //       } else {
      //         rightAddButton.disabled = false;
      //         const span = rightAddButton.querySelector('span');
      //         if (span) span.textContent = window.variantStrings.addToCart;
      //       }
      //     }
      //   }
      // }
      // ========== 新增结束 ==========
        publish(PUB_SUB_EVENTS.variantChange, {
          data: {
            sectionId,
            html,
            variant: this.currentVariant,
          },
        });
        if(typeof Globo != "undefined" && typeof Globo.Preorder != "undefined" ) {
         Globo.Preorder.initPreorder?.();
         Globo.Preorder.showPreorderLabel?.();
      }
      });
  }

  toggleAddButton(disable = true, text, modifyClass = true) {

    var formIds = [
      'product-form-' + this.dataset.section,
      'product-form-' + this.dataset.section + '-desktop'
    ];

    formIds.forEach(function(formId) {
      var productForm = document.getElementById(formId);
      if (!productForm) return;

      var buttons = productForm.querySelectorAll('[name="add"], [name="buy_now"]');
      buttons.forEach(function(button) {
        if (disable) {
          button.setAttribute('disabled', 'disabled');
          if (text && button.name !== 'buy_now') {
            var span = button.querySelector('span');
            if (span) span.textContent = text;
          }
        } else {
          button.removeAttribute('disabled');
          var span = button.querySelector('span');
          if (span) {
            span.textContent = button.name === 'buy_now'
              ? 'Buy it now'
              : window.variantStrings.addToCart;
          }
        }
      });
    });

    if (!modifyClass) return;
  }


  setUnavailable() {
    var formIds = [
      'product-form-' + this.dataset.section,
      'product-form-' + this.dataset.section + '-desktop'
    ];

    formIds.forEach(function(formId) {
      var productForm = document.getElementById(formId);
      if (!productForm) return;

      var addButton = productForm.querySelector('[name="add"]');
      var buyNowButton = productForm.querySelector('[name="buy_now"]');

      if (addButton) {
        var addButtonText = addButton.querySelector('span');
        if (addButtonText) addButtonText.textContent = window.variantStrings.unavailable;
        addButton.setAttribute('disabled', 'disabled');
      }
      if (buyNowButton) {
        buyNowButton.setAttribute('disabled', 'disabled');
        // Buy it now text stays unchanged
      }
    });

    const price = document.getElementById(`price-${this.dataset.section}`);
    const inventory = document.getElementById(`Inventory-${this.dataset.section}`);
    const sku = document.getElementById(`Sku-${this.dataset.section}`);
    const pricePerItem = document.getElementById(`Price-Per-Item-${this.dataset.section}`);
    const volumeNote = document.getElementById(`Volume-Note-${this.dataset.section}`);
    const volumeTable = document.getElementById(`Volume-${this.dataset.section}`);
    const qtyRules = document.getElementById(`Quantity-Rules-${this.dataset.section}`);

    if (price) price.classList.add('hidden');
    if (inventory) inventory.classList.add('hidden');
    if (sku) sku.classList.add('hidden');
    if (pricePerItem) pricePerItem.classList.add('hidden');
    if (volumeNote) volumeNote.classList.add('hidden');
    if (volumeTable) volumeTable.classList.add('hidden');
    if (qtyRules) qtyRules.classList.add('hidden');
  }

  getVariantData() {
    this.variantData = this.variantData || JSON.parse(this.querySelector('[type="application/json"]').textContent);
    return this.variantData;
  }
}

customElements.define('variant-selects', VariantSelects);

class ProductRecommendations extends HTMLElement {
  constructor() {
    super();
  }

  connectedCallback() {
    const loadRecommendations = () => {
      if (this.dataset.loading === 'true') return;
      this.dataset.loading = 'true';

      fetch(this.dataset.url)
        .then((response) => response.text())
        .then((text) => {
          const html = document.createElement('div');
          html.innerHTML = text;
          const recommendations = html.querySelector('product-recommendations');

          if (recommendations && recommendations.innerHTML.trim().length) {
            this.innerHTML = recommendations.innerHTML;
          }

          if (!this.querySelector('slideshow-component') && this.classList.contains('complementary-products')) {
            this.remove();
          }

          if (html.querySelector('.grid__item')) {
            this.classList.add('product-recommendations--loaded');
          }
        })
        .catch((e) => {
          console.error(e);
        })
        .finally(() => {
          delete this.dataset.loading;
        });
    };

    if (this.dataset.loadImmediately === 'true') {
      loadRecommendations();
      return;
    }

    const handleIntersection = (entries, observer) => {
      if (!entries[0].isIntersecting) return;
      observer.unobserve(this);
      loadRecommendations();
    };

    new IntersectionObserver(handleIntersection.bind(this), { rootMargin: '0px 0px 400px 0px' }).observe(this);
  }
}

customElements.define('product-recommendations', ProductRecommendations);

// Judge.me injects and may re-render this tab after the theme CSS has loaded.
(() => {
  const REVIEWS_TAB_SELECTOR = '.jdgm-subtab > .jdgm-subtab__name[data-tabname="reviews"]';
  let hideScheduled = false;

  const hideReviewsTabs = () => {
    document.querySelectorAll(REVIEWS_TAB_SELECTOR).forEach((tab) => {
      tab.hidden = true;
      tab.setAttribute('aria-hidden', 'true');
      tab.setAttribute('tabindex', '-1');
      tab.style.setProperty('display', 'none', 'important');
    });
  };

  const scheduleHide = () => {
    if (hideScheduled) return;
    hideScheduled = true;

    requestAnimationFrame(() => {
      hideScheduled = false;
      hideReviewsTabs();
    });
  };

  hideReviewsTabs();

  new MutationObserver(scheduleHide).observe(document.documentElement, {
    childList: true,
    subtree: true,
  });
})();

// Keep Judge.me pagination stable while it replaces the review list, then scroll once.
(() => {
  const REVIEWS_HEADING_ID = 'reviews-qa-heading';
  const PAGINATION_SELECTOR = '.jdgm-paginate__page[data-page]';
  const STICKY_TOP_BAR_SELECTOR = '.section-header.shopify-section-header-sticky, .announce_bar_mobile';
  const HEADING_TOP_GAP = 12;
  const UPDATE_SETTLE_DELAY = 180;
  const UPDATE_TIMEOUT = 5000;
  const POST_UPDATE_SCROLL_GUARD = 1000;
  let reviewUpdateObserver = null;
  let reviewUpdateTimer = null;
  let reviewSettleTimer = null;
  let viewportLock = null;

  const ensureReviewsHeading = (widget) => {
    const authoredHeading = document.querySelector('.reviews-qa-heading:not(.reviews-qa-heading--generated)');
    const currentHeading = document.getElementById(REVIEWS_HEADING_ID);

    if (authoredHeading) {
      if (currentHeading !== authoredHeading && currentHeading?.classList.contains('reviews-qa-heading--generated')) {
        currentHeading.remove();
      }
      authoredHeading.id = REVIEWS_HEADING_ID;
      return authoredHeading;
    }

    if (currentHeading) return currentHeading;
    if (!widget) return null;

    const appBlock = widget.closest('.shopify-app-block');
    const headingParent = appBlock?.parentElement || widget.parentElement;
    if (!headingParent) return null;

    const heading = document.createElement('h2');
    heading.id = REVIEWS_HEADING_ID;
    heading.className = 'reviews-qa-heading reviews-qa-heading--generated';
    heading.textContent = 'Customer Reviews';
    headingParent.insertBefore(heading, appBlock || widget);
    return heading;
  };

  const getStickyTopOffset = () => {
    let offset = 0;

    document.querySelectorAll(STICKY_TOP_BAR_SELECTOR).forEach((bar) => {
      const style = window.getComputedStyle(bar);
      const rect = bar.getBoundingClientRect();
      const isTopBar = style.position === 'sticky' || style.position === 'fixed';
      const isVisible =
        style.display !== 'none' &&
        style.visibility !== 'hidden' &&
        Number(style.opacity) !== 0 &&
        rect.width > 0 &&
        rect.height > 0;

      if (!isTopBar || !isVisible) return;

      // Dawn hides the header while scrolling down, but reveals it again on the upward
      // pagination scroll. Reserve its revealed position so it cannot cover the heading.
      const configuredTop = bar.matches('.section-header') ? 0 : Number.parseFloat(style.top);
      const revealedTop = Number.isFinite(configuredTop) ? Math.max(0, configuredTop) : Math.max(0, rect.top);
      offset = Math.max(offset, revealedTop + rect.height);
    });

    return Math.ceil(offset);
  };

  const getReviewsScrollTop = (heading) => {
    const section = heading.closest('.shopify-section') || heading;
    const desiredTop = getStickyTopOffset() + HEADING_TOP_GAP;
    return Math.max(0, window.scrollY + section.getBoundingClientRect().top - desiredTop);
  };

  const lockViewport = () => {
    const position = { left: window.scrollX, top: window.scrollY };
    const root = document.documentElement;
    const body = document.body;
    const originalWindowScrollTo = window.scrollTo;
    const originalScrollBehavior = root.style.scrollBehavior;
    const originalRootOverflowAnchor = root.style.overflowAnchor;
    const originalBodyOverflowAnchor = body?.style.overflowAnchor || '';
    const scrollTopDescriptor = Object.getOwnPropertyDescriptor(Element.prototype, 'scrollTop');
    const rootScrollDescriptors = new Map();
    const blockedWindowScrollTo = () => {};
    let lockFrame = null;
    let holdingPosition = true;
    let programmaticScrollBlocked = true;

    const restorePosition = () => {
      if (!holdingPosition) return;
      if (window.scrollX === position.left && window.scrollY === position.top) return;
      originalWindowScrollTo.call(window, position.left, position.top);
    };

    const blockRootScroll = (element) => {
      if (!element || !scrollTopDescriptor?.get || !scrollTopDescriptor?.set) return;

      const originalDescriptor = Object.getOwnPropertyDescriptor(element, 'scrollTop');
      try {
        Object.defineProperty(element, 'scrollTop', {
          configurable: true,
          enumerable: scrollTopDescriptor.enumerable,
          get: () => scrollTopDescriptor.get.call(element),
          set: (value) => {
            if (!programmaticScrollBlocked) scrollTopDescriptor.set.call(element, value);
          },
        });
        rootScrollDescriptors.set(element, originalDescriptor);
      } catch (error) {
        // The animation-frame lock remains as a fallback in restricted browsers.
      }
    };

    const holdPosition = () => {
      if (!holdingPosition) return;
      restorePosition();
      lockFrame = requestAnimationFrame(holdPosition);
    };

    const stopHoldingPosition = () => {
      if (!holdingPosition) return;
      holdingPosition = false;
      if (lockFrame !== null) cancelAnimationFrame(lockFrame);
      lockFrame = null;
      window.removeEventListener('scroll', restorePosition);
    };

    const restoreProgrammaticScroll = () => {
      if (!programmaticScrollBlocked) return;
      programmaticScrollBlocked = false;

      if (window.scrollTo === blockedWindowScrollTo) window.scrollTo = originalWindowScrollTo;
      rootScrollDescriptors.forEach((descriptor, element) => {
        if (descriptor) {
          Object.defineProperty(element, 'scrollTop', descriptor);
        } else {
          delete element.scrollTop;
        }
      });
      rootScrollDescriptors.clear();
      root.style.scrollBehavior = originalScrollBehavior;
      root.style.overflowAnchor = originalRootOverflowAnchor;
      if (body) body.style.overflowAnchor = originalBodyOverflowAnchor;
    };

    root.style.scrollBehavior = 'auto';
    root.style.overflowAnchor = 'none';
    if (body) body.style.overflowAnchor = 'none';
    window.scrollTo = blockedWindowScrollTo;
    blockRootScroll(root);
    blockRootScroll(body);
    window.addEventListener('scroll', restorePosition, { passive: true });
    lockFrame = requestAnimationFrame(holdPosition);

    return {
      release: () => {
        stopHoldingPosition();
        restoreProgrammaticScroll();
        originalWindowScrollTo.call(window, position.left, position.top);
      },
      scrollTo: (options) => {
        stopHoldingPosition();
        originalWindowScrollTo.call(window, options);
        window.setTimeout(restoreProgrammaticScroll, POST_UPDATE_SCROLL_GUARD);
      },
    };
  };

  const clearReviewUpdate = () => {
    reviewUpdateObserver?.disconnect();
    reviewUpdateObserver = null;
    if (reviewUpdateTimer !== null) window.clearTimeout(reviewUpdateTimer);
    if (reviewSettleTimer !== null) window.clearTimeout(reviewSettleTimer);
    reviewUpdateTimer = null;
    reviewSettleTimer = null;
  };

  const releaseReviewViewport = () => {
    viewportLock?.release();
    viewportLock = null;
  };

  const scrollToReviewsHeading = (heading) => {
    if (!heading?.isConnected) {
      releaseReviewViewport();
      return;
    }

    requestAnimationFrame(() => {
      if (!heading.isConnected) {
        releaseReviewViewport();
        return;
      }

      const reduceMotion = window.matchMedia?.('(prefers-reduced-motion: reduce)').matches;
      const scrollOptions = {
        left: window.scrollX,
        top: getReviewsScrollTop(heading),
        behavior: reduceMotion ? 'auto' : 'smooth',
      };

      if (viewportLock) {
        viewportLock.scrollTo(scrollOptions);
        viewportLock = null;
      } else {
        window.scrollTo(scrollOptions);
      }
    });
  };

  const waitForReviewPage = (heading, widget, targetPage) => {
    clearReviewUpdate();
    releaseReviewViewport();
    viewportLock = lockViewport();

    const finishUpdate = () => {
      clearReviewUpdate();
      scrollToReviewsHeading(heading);
    };

    const scheduleScroll = () => {
      const currentPage = widget.querySelector('.jdgm-paginate .jdgm-curt[data-page]')?.dataset.page;
      if (currentPage !== targetPage) return;

      if (reviewSettleTimer !== null) window.clearTimeout(reviewSettleTimer);
      reviewSettleTimer = window.setTimeout(finishUpdate, UPDATE_SETTLE_DELAY);
    };

    reviewUpdateObserver = new MutationObserver(scheduleScroll);
    reviewUpdateObserver.observe(widget, {
      attributes: true,
      attributeFilter: ['class'],
      childList: true,
      subtree: true,
    });
    reviewUpdateTimer = window.setTimeout(() => {
      const pageChanged = widget.querySelector('.jdgm-paginate .jdgm-curt[data-page]')?.dataset.page === targetPage;
      clearReviewUpdate();
      if (pageChanged) {
        scrollToReviewsHeading(heading);
      } else {
        releaseReviewViewport();
      }
    }, UPDATE_TIMEOUT);
  };

  const initializeReviewsHeading = () => {
    const widget = document.querySelector('.jdgm-review-widget, .jdgm-widget[data-widget="review"]');
    if (!widget) return false;

    ensureReviewsHeading(widget);
    return true;
  };

  if (!initializeReviewsHeading()) {
    const widgetObserver = new MutationObserver(() => {
      if (!initializeReviewsHeading()) return;
      widgetObserver.disconnect();
    });
    widgetObserver.observe(document.getElementById('MainContent') || document.documentElement, {
      childList: true,
      subtree: true,
    });
  }

  document.addEventListener('shopify:section:load', initializeReviewsHeading);

  document.addEventListener(
    'click',
    (event) => {
      if (!(event.target instanceof Element)) return;

      const pageControl = event.target.closest(PAGINATION_SELECTOR);
      if (!pageControl || !pageControl.closest('.jdgm-paginate')) return;
      if (pageControl.classList.contains('jdgm-curt')) return;

      const widget = pageControl.closest('.jdgm-review-widget, .jdgm-widget');
      const heading = ensureReviewsHeading(widget);
      const targetPage = pageControl.dataset.page;
      if (!heading || !widget || !targetPage) return;

      waitForReviewPage(heading, widget, targetPage);
    },
    true
  );
})();

// Let Judge.me refresh a sorted review list without moving the viewport.
(() => {
  let lockFrame = null;
  let lockPosition = null;
  let lockUntil = 0;
  let originalScrollBehavior = '';
  let originalWindowScrollTo = null;
  let pendingDropdown = null;
  let pendingPosition = null;
  const scrollTopDescriptor = Object.getOwnPropertyDescriptor(Element.prototype, 'scrollTop');
  const rootScrollDescriptors = new Map();

  const findSortDropdown = (target) => {
    if (!(target instanceof Element)) return null;

    const wrapper = target.closest('.jdgm-row-actions .jdgm-sort-dropdown-wrapper');
    return wrapper?.querySelector('.jdgm-sort-dropdown') || null;
  };

  const rememberPosition = (event) => {
    const sortDropdown = findSortDropdown(event.target);
    if (!sortDropdown) return;

    pendingDropdown = sortDropdown;
    pendingPosition = { left: window.scrollX, top: window.scrollY };
  };

  const restoreScroll = () => {
    if (!lockPosition) return;
    if (window.scrollX === lockPosition.left && window.scrollY === lockPosition.top) return;

    (originalWindowScrollTo || window.scrollTo).call(window, lockPosition.left, lockPosition.top);
  };

  const blockRootScroll = (element) => {
    if (!element || !scrollTopDescriptor?.get || !scrollTopDescriptor?.set) return;

    const originalDescriptor = Object.getOwnPropertyDescriptor(element, 'scrollTop');
    try {
      Object.defineProperty(element, 'scrollTop', {
        configurable: true,
        enumerable: scrollTopDescriptor.enumerable,
        get: () => scrollTopDescriptor.get.call(element),
        set: (value) => {
          if (!lockPosition) scrollTopDescriptor.set.call(element, value);
        },
      });
      rootScrollDescriptors.set(element, originalDescriptor);
    } catch (error) {
      // The animation-frame lock remains as a fallback for restricted DOM implementations.
    }
  };

  const blockProgrammaticScroll = () => {
    originalWindowScrollTo = window.scrollTo;
    window.scrollTo = () => {};
    blockRootScroll(document.documentElement);
    blockRootScroll(document.body);
  };

  const restoreProgrammaticScroll = () => {
    if (originalWindowScrollTo) {
      window.scrollTo = originalWindowScrollTo;
      originalWindowScrollTo = null;
    }

    rootScrollDescriptors.forEach((descriptor, element) => {
      if (descriptor) {
        Object.defineProperty(element, 'scrollTop', descriptor);
      } else {
        delete element.scrollTop;
      }
    });
    rootScrollDescriptors.clear();
  };

  const finishLock = () => {
    const finalPosition = lockPosition;
    restoreProgrammaticScroll();
    if (finalPosition) window.scrollTo(finalPosition.left, finalPosition.top);

    window.removeEventListener('scroll', restoreScroll);
    document.documentElement.style.scrollBehavior = originalScrollBehavior;
    lockFrame = null;
    lockPosition = null;
  };

  const holdPosition = (now) => {
    restoreScroll();

    if (now < lockUntil) {
      lockFrame = requestAnimationFrame(holdPosition);
      return;
    }

    finishLock();
  };

  const lockScroll = (position) => {
    lockPosition = position;
    lockUntil = performance.now() + 1500;

    if (lockFrame !== null) {
      cancelAnimationFrame(lockFrame);
    } else {
      originalScrollBehavior = document.documentElement.style.scrollBehavior;
      document.documentElement.style.scrollBehavior = 'auto';
      window.addEventListener('scroll', restoreScroll, { passive: true });
      blockProgrammaticScroll();
    }

    restoreScroll();
    lockFrame = requestAnimationFrame(holdPosition);
  };

  document.addEventListener('pointerdown', rememberPosition, true);
  document.addEventListener('keydown', rememberPosition, true);

  document.addEventListener(
    'change',
    (event) => {
      const sortDropdown = findSortDropdown(event.target);
      if (!sortDropdown) return;

      const scrollPosition =
        pendingDropdown === sortDropdown && pendingPosition
          ? pendingPosition
          : { left: window.scrollX, top: window.scrollY };

      pendingDropdown = null;
      pendingPosition = null;
      lockScroll(scrollPosition);
    },
    true
  );
})();
